import React, { useContext, useState } from "react";
import cx from "classnames";
import * as R from "ramda";
import { func, string, array } from "prop-types";

import useClickAway from "../../../../common/useClickAway.js";

import RadioBox from "../../../FormItems/RadioBox.jsx";

const propTypes = {
  label: string,
  id: string,
  values: array,
  param: string,
  dropdownLabel: string,
  onFacetChange: func.isRequired,
  type: string,
};

const FilterDropdown = (props) => {
  const { label, id, dropdownLabel, onFacetChange, values, param, type } =
    props;

  const [isOpen, setOpen] = useState(false);
  const filterDropdownRef = useClickAway({ isOpen, setOpen });

  if (!values || values.length < 1) {
    return null;
  }

  /**
   * values:
   * [
   *   {
   *     "url": "http://sfp.docker.localhost/api/v1/site-search?f%5B0%5D=topics%3A16&;f%5B1%5D=topics%3A41",
   *     "raw_value": "16",
   *     "values": {
   *       "value": "Test",
   *       "count": 12,
   *       "active": true
   *     }
   *   },
   * ]
   */

  const inActive = (n) =>
    n.values.active !== "true" && n.values.active !== true;

  const selectedNamesArray = R.map(R.path(["values", "value"]))(
    R.reject(inActive, values),
  );

  const selectedText =
    selectedNamesArray.length > 3
      ? `${selectedNamesArray.slice(0, 3).join(", ")} and ${
          selectedNamesArray.length - 3
        } others selected`
      : selectedNamesArray.join(", ");

  /**
   * RadioBox:
   *
   * label: the printed label for the box
   * id: the id of the facet/sort
   * name:
   */

  const renderGroup = (values) => {
    return (
      values &&
      values.map((value, ind) => {
        return (
          <li key={`${value.raw_value}-${ind}`}>
            <RadioBox
              type="checkbox"
              label={`${value.values.value}`}
              id={value.raw_value}
              name={value.values.value}
              checked={value.values.active}
              onChange={() => onFacetChange(param, value.raw_value, value)}
            />
          </li>
        );
      })
    );
  };

  // const count =
  //   selectedFacets?.[id] && selectedFacets[id].split(",").length > 0
  //     ? `(${Object.keys(selectedFacets[id]).length})`
  //     : "";

  const handleMenuClick = () => {
    setOpen(!isOpen);
  };

  return (
    <section
      ref={filterDropdownRef}
      className={`filter-dropdown filter-dropdown--${type}`}
    >
      <div
        id={`filter-${label}-${id}`.replace(/\s/g, "")}
        className="filter-dropdown__eyebrow"
      >
        {dropdownLabel || label}
      </div>
      <div className="filter-dropdown__header">
        <button
          aria-labelledby={`filter-${label}-${id}`.replace(/\s/g, "")}
          aria-expanded={isOpen}
          type="button"
          id={id}
          onClick={handleMenuClick}
          className="filter-dropdown__open-button"
        >
          <span className="filter-dropdown__filter-text-wrapper">
            {selectedText || label}
          </span>
          <span className="icon" />
        </button>
      </div>
      <div
        className={cx("filter-dropdown__panel", {
          "filter-dropdown__panel--is-open": isOpen,
        })}
      >
        <div className="filter-dropdown__menu-list">
          <ul className="filter-dropdown__group" aria-label={label}>
            {renderGroup(values)}
          </ul>
        </div>
      </div>
    </section>
  );
};

FilterDropdown.propTypes = propTypes;
export default React.memo(FilterDropdown);
